<template>
  <div class="ListRiskAnalysis">
    <HeaderPage>
    </HeaderPage>
    <el-card shadow="never" :body-style="{ padding: '0px' }" style="background-color: transparent; border: none" v-loading="loadingPage">
      <el-tabs v-model="activeName" type="card" style="margin: 20px auto 0 auto; ">
        <el-tab-pane name="estabelecimento-comercial">
          <span slot="label">Estabelecimento Comercial</span>
          <el-row :gutter="20">
            <FilterBoxAppAccou v-on:filter="listDados" :currentPage="listData.meta ? listData.meta.pagination.current_page : 1" />
            <TableSimple :list-data="listData" @paginationClick="paginationClick">
              <el-table-column prop="id_status" label="ID" width = '50px'/>
              <el-table-column prop="type" label="Tipo" width = '140px'>
                <template slot-scope="scope">
                  {{ (scope.row.department_store_id) ? 'Estabelecimento Comercial' : (scope.row.marketplace_id) ? 'Marketplace' : 'Representante' }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="Nome" />
              <el-table-column prop="document" label="Documento">
                <template slot-scope="scope">
                  {{ (scope.row.business_cnpj) ? scope.row.business_cnpj : scope.row.cpf }}
                </template>
              </el-table-column>
              <el-table-column prop="marketplace_name" label="Marketplace">
                <template slot-scope="scope">
                  {{ (scope.row.department_store_id) ? scope.row.marketplace_name : scope.row.agent_marketplace_name }}
                </template>
              </el-table-column>
              <el-table-column prop="marketplace_document" label="Documento Marketplace">
                <template slot-scope="scope">
                  {{ (scope.row.department_store_id) ? scope.row.marketplace_document : scope.row.agent_marketplace_document }}
                </template>
              </el-table-column>
              <el-table-column prop="type_person" label="Tipo de pessoa">
                <template slot-scope="scope">
                  {{ (scope.row.type_person == 'individual') ? 'Individual' : 'Empresa'  }}
                </template>
              </el-table-column>
              <el-table-column prop="status" label="Status">
                <template slot-scope="scope">
                  <StatusCapta v-if="scope.row.status" :status="scope.row.status" :isBeneficiary="true" />
                </template>
              </el-table-column>
              <el-table-column prop="created_at" label="Criado em" width="130">
                <template slot-scope="scope">
                  {{moment(scope.row.created_at).format('DD/MM/YY HH:mm')}}
                </template>
              </el-table-column>
              <el-table-column prop="updated_at" label="Atualizado em" width="130">
                <template slot-scope="scope">
                  {{moment(scope.row.updated_at).format('DD/MM/YY HH:mm')}}
                </template>
              </el-table-column>
              <el-table-column width="55">
                <template slot-scope="scope">
                  <el-button v-if="!$can('2|4|5')" type="text" @click="() => {$router.push({name: 'records.riskAnalysis.view', params: { id: scope.row.id }})}">
                    <SearchIcon size="1.2x" style="padding: 0 7px;"></SearchIcon>
                  </el-button>
                </template>
              </el-table-column>
            </TableSimple>
          </el-row>
        </el-tab-pane>
        <el-tab-pane name="beneficiario-estabelecimento-comercial">
          <span slot="label">Beneficiário do Estabelecimento Comercial</span>
          <el-row :gutter="20">
            <FiltroBeneficiario v-on:filter="listDadosBeneficiarios" :currentPage="listDataBeneficiarios.meta ? listDataBeneficiarios.meta.pagination.current_page : 1" />
            <TableSimple :list-data="listDataBeneficiarios" @paginationClick="paginationBeneficiarioClick">
              <el-table-column prop="id" label="ID" width = '50px'/>
              <el-table-column prop="titular" label="Nome" />
              <el-table-column prop="document" label="Documento">
                <template slot-scope="scope">
                  {{ scope.row.document }}
                </template>
              </el-table-column>
              <el-table-column prop="type_person" label="Tipo de pessoa">
                <template slot-scope="scope">
                  {{ (scope.row.type_person == 'individual') ? 'Individual' : 'Empresa'  }}
                </template>
              </el-table-column>
              <el-table-column prop="status" label="Status" min-width="160">
                <template slot-scope="scope">
                  <StatusCapta v-if="scope.row.status" :status="scope.row.status" :isBeneficiary="true" />
                </template>
              </el-table-column>
              <el-table-column prop="created_at" label="Criado em" width="130">
                <template slot-scope="scope">
                  {{moment(scope.row.created_at).format('DD/MM/YY HH:mm')}}
                </template>
              </el-table-column>
              <el-table-column prop="updated_at" label="Atualizado em" width="130">
                <template slot-scope="scope">
                  {{moment(scope.row.updated_at).format('DD/MM/YY HH:mm')}}
                </template>
              </el-table-column>
              <el-table-column width="55">
                <template slot-scope="scope">
                  <el-button v-if="!$can('2|4|5')" type="text" @click="() => {$router.push({name: 'records.riskAnalysisBeneficiary.view', params: { id: scope.row.id }})}">
                    <SearchIcon size="1.2x" style="padding: 0 7px;"></SearchIcon>
                  </el-button>
                </template>
              </el-table-column>
            </TableSimple>
          </el-row>
        </el-tab-pane>
        <el-tab-pane name="ec-digital-analise" v-if="$can('RISK_ANALYSIS_DIGITAL_PAYMENT')">
          <span slot="label">EC Pagamentos Digitais</span>
          <el-row :gutter="20">
            <FilterBoxAppAccou v-on:filter="listDigitalAnalysis" :currentPage="listDataDigitalAnalysis.meta ? listDataDigitalAnalysis.meta.pagination.current_page : 1" />
            <TableSimple :list-data="listDataDigitalAnalysis" @paginationClick="paginationClick">
              <el-table-column prop="id_status" label="ID" width = '65px'/>
              <el-table-column prop="type" label="Tipo" width = '140px'>
                <template>
                  Estabelecimento Comercial
                </template>
              </el-table-column>
              <el-table-column prop="name_store" label="Nome" />
              <el-table-column prop="document" label="Documento">
                <template slot-scope="scope">
                  {{ (scope.row.business_cnpj) ? scope.row.business_cnpj : scope.row.cpf }}
                </template>
              </el-table-column>
              <el-table-column prop="marketplace_name" label="Marketplace">
                <template slot-scope="scope">
                  {{ (scope.row.department_store_id) ? scope.row.marketplace_name : scope.row.agent_marketplace_name }}
                </template>
              </el-table-column>
              <el-table-column prop="marketplace_document" label="Documento Marketplace">
                <template slot-scope="scope">
                  {{ (scope.row.department_store_id) ? scope.row.marketplace_document : scope.row.agent_marketplace_document }}
                </template>
              </el-table-column>
              <el-table-column prop="type_person" label="Tipo de pessoa">
                <template slot-scope="scope">
                  {{ (scope.row.type_person == 'individual') ? 'Individual' : 'Empresa'  }}
                </template>
              </el-table-column>
              <el-table-column prop="status" label="Status">
                <template slot-scope="scope">
                  <tagStatus :status="scope.row.status" />
                </template>
              </el-table-column>
              <el-table-column prop="created_at" label="Criado em" width="130">
                <template slot-scope="scope">
                  {{moment(scope.row.created_at).format('DD/MM/YY HH:mm')}}
                </template>
              </el-table-column>
              <el-table-column prop="updated_at" label="Atualizado em" width="130">
                <template slot-scope="scope">
                  {{moment(scope.row.updated_at).format('DD/MM/YY HH:mm')}}
                </template>
              </el-table-column>
              <el-table-column width="55">
                <template slot-scope="scope">
                  <el-button v-if="!$can('2|4|5')" type="text" @click="() => {$router.push({name: 'records.riskAnalysisDigital.view', params: { id: scope.row.id }})}">
                    <SearchIcon size="1.2x" style="padding: 0 7px;"></SearchIcon>
                  </el-button>
                </template>
              </el-table-column>
            </TableSimple>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import TableSimple from "@/app/components/Table/TableSimple";
import {SearchIcon} from "vue-feather-icons";
import {
  getListaAnaliseRisco,
  getListaAnaliseRiscoBeneficiarios,
  getListDigitalAnalysis
} from "@/app/domains/Records/services";
import tagStatus from "@/app/components/Table/TagStatus";
import FilterBoxAppAccou from "@/app/domains/RiskAnalysis/components/FilterBoxAppAccou";
import FiltroBeneficiario from "@/app/domains/RiskAnalysis/components/FiltroBeneficiario";
import {makeErrorFilds} from "@/app/plugins/utils";
import StatusCapta from "@/app/domains/Records/components/EstabelecimentoComercial/_statusCapta";
import TagStatus from "@/app/components/Table/TagStatus.vue";

export default {
  name: "ListRiskAnalysis",
  components: {
    TagStatus,
    HeaderPage,
    TableSimple,
    SearchIcon,
    FilterBoxAppAccou,
    FiltroBeneficiario,
    StatusCapta,
  },
  data () {
    return {
      loadingPage: false,
      listData: {},
      listDataDigitalAnalysis: {},
      listDataBeneficiarios: {},
      query: '?page=1',
      activeName: "estabelecimento-comercial",
    }
  },

  methods: {
    init () {
      this.listDados();
      this.listDadosBeneficiarios();
      this.listDigitalAnalysis();
    },
    paginationClick (arg) {
      const newQueryString = this.query
        .replace(/[?&](page|per_page)=[^&]+/gi, "") // Remove as informações de "page" e "per_page"
        .replace(/^[?&]/, "");
      this.listDados(
        "?" + newQueryString + "&page=" + arg.page + `&per_page=${arg.meta.per_page}`
      );
    },
    paginationBeneficiarioClick (arg) {
      const newQueryString = this.query
        .replace(/[?&](page|per_page)=[^&]+/gi, "") // Remove as informações de "page" e "per_page"
        .replace(/^[?&]/, "");
      this.listDadosBeneficiarios(
        "?" + newQueryString + "&page=" + arg.page + `&per_page=${arg.meta.per_page}`
      );
    },
    async listDados (query = '') {
      this.loadingPage = true
      this.error = {}
      this.query = query;
      try {
        let response = await getListaAnaliseRisco(query)
        this.listData = response.data
      } catch (e) {

        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    async listDigitalAnalysis (query = '') {
      this.loadingPage = true
      this.error = {}
      this.query = query;
      try {
        let response = await getListDigitalAnalysis(query)
        this.listDataDigitalAnalysis = response.data
      } catch (e) {

        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    async listDadosBeneficiarios (query = '') {
      this.loadingPage = true
      this.error = {}
      this.query = query;
      try {
        let response = await getListaAnaliseRiscoBeneficiarios(query)
        this.listDataBeneficiarios = response.data
      } catch (e) {

        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>
